<template>
  <div class="mb-4">
    <p class="subtitle-1 ma-0 font-weight-bold secondary--text">
      {{ (event || {}).zone || "Lugar sin descripción" }}
    </p>
    <p class="blue-grey--text">
      <span>Lat. {{ (center || {}).lat }}</span>
      <span class="pl-3">Long. {{ (center || {}).lng }}</span>
    </p>
    <LMap
      :zoom="zoom"
      :center="center"
      v-if="center"
      :options="mapOptions"
      ref="map"
      style="z-index:0; height:616px"
      class="rounded-custom"
    >
      <LMarker :lat-lng="center"></LMarker>
    </LMap>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
export default {
  components: { LMap, LTileLayer, LMarker },
  props: ["event"],
  data: () => ({
    mapOptions: {
      zoomControl: false,
      dragging: false,
      boxZoom: false,
      doubleClickZoom: false,
      scrollWheelZoom: false
    },
    zoom: 13,
    center: null,
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
  }),
  mounted() {
    let [lng, lat] = this.event.coordinates;
    this.center = { lat, lng };

    setTimeout(() => {
      L.tileLayer
        .bing({
          bingMapsKey:
            "AqZzddAfYuAhbM8Ez9sYiA81Of7Y9xM2idIEFhDH7nc_897g4AMq4TpnKvdmP0To",
          imagerySet: "AerialWithLabels"
        })
        .addTo(this.$refs.map.mapObject);
    });
  }
};
</script>
